import { useTranslation } from 'react-i18next';

type Point = { subKey: string; bodyKey: string; altKey: string; img: string };

const points: Point[] = [
  {
    subKey: 'aboutAcademy.identity.1.sub',
    bodyKey: 'aboutAcademy.identity.1.body',
    altKey: 'aboutAcademy.identity.1.imgAlt',
    img: '/images/generated/association-hero-2026.jpg',
  },
  {
    subKey: 'aboutAcademy.identity.2.sub',
    bodyKey: 'aboutAcademy.identity.2.body',
    altKey: 'aboutAcademy.identity.2.imgAlt',
    img: '/images/generated/association-cert-2026.jpg',
  },
  {
    subKey: 'aboutAcademy.identity.3.sub',
    bodyKey: 'aboutAcademy.identity.3.body',
    altKey: 'aboutAcademy.identity.3.imgAlt',
    img: '/images/generated/facilities-campus-2026.jpg',
  },
];

export default function AcademyIdentity() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('aboutAcademy.identity.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('aboutAcademy.identity.title')}
          </h2>
          {String(t('aboutAcademy.identity.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('aboutAcademy.identity.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-[2] max-w-[760px] mx-auto text-left md:text-center">{__s}</p>))}
        </div>

        <div className="space-y-14 md:space-y-20">
          {points.map((point, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <div
                key={point.subKey}
                className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center"
              >
                <div className={`lg:col-span-6 ${reverse ? 'lg:order-2' : 'lg:order-1'}`}>
                  <div className="relative">
                    <div className="absolute -inset-2 border border-accent-500/20 pointer-events-none hidden md:block"></div>
                    <img
                      src={point.img}
                      alt={t(point.altKey)}
                      className="relative w-full aspect-[4/3] object-cover object-center"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className={`lg:col-span-6 ${reverse ? 'lg:order-1' : 'lg:order-2'}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="w-8 h-px bg-accent-500/60"></span>
                    <span className="section-title-en text-accent-600/80 text-[13px] tracking-[0.16em]">
                      0{idx + 1}
                    </span>
                  </div>
                  <h3 className="font-heading text-[19px] md:text-[23px] text-foreground-900 tracking-[0.05em] leading-[1.6] mb-5">
                    {t(point.subKey)}
                  </h3>
                  {String(t(point.bodyKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] md:text-[17px] text-foreground-600 tracking-[0.03em] leading-[2.05]">{__s}</p>))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
